import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/LouveRoofGold.png"
      {...props}
    />
  );
}

export default Logo;
